import React, {useContext} from 'react';
import {createRoot} from 'react-dom/client';
import BaseComponent from '../../common/BaseComponent/BaseComponent';
import styles from './PageDomainSingle.scss'
import whiteBox from "../../common/scss/WhiteBox.scss";
import ComponentHeaderPublic from '../../components/ComponentHeaderPublic/ComponentHeaderPublic';
import {__t} from '../../common/lang/text-resource';
import ComponentFooter from '../../components/ComponentFooter/ComponentFooter';
import ComponentSearchDomainForm from '../../components/ComponentSearchDomainForm/ComponentSearchDomainForm';
import {ContextServicePrice, ContextServicePriceProvider} from '../../context/ContextServicePriceProvider';
import {FormatPrice} from '../../common/primitives/Price';
import DomainLabelNew from '../../common/primitives/DomainLabelNew';
import DomainHeader from './Headers/DomainHeader';

class PageDomainSingle extends BaseComponent {

	constructor() {
		super(...arguments, 'PageDomainSingle');
		SHVO.pageComponent = this;
	}


	render() {
		const {
			header,
			tld,
			tldId,
			xnOnly,
			text,
			image,
			priceTransfer,
			basePriceTransfer,
			promoDateEnd,
			promoMessage,
			domLabels
		} = this.props.data.componentData;
		return (
		  <>
			  <ComponentHeaderPublic data={header} isLazy={"1"}/>
			  <DomainHeader xnOnly={xnOnly} tld={tld}/>
			  <section role="main" className={styles[tldId]}>
				  <ContextServicePriceProvider>
					  <div className={styles.introContainer}>
						  <div className={`${whiteBox.container} ${styles.intro}`}>
							  <div className={styles.introRow}>
								  <div>
									  <div dangerouslySetInnerHTML={{__html: text}}/>
									  {tld == 'com' && (
										<a href="/web-hosting-order-domain-transfer.php" target="_blank">
											{__t('Вече имате .COM домейн? Прехвърлете го при нас!')}
										</a>
									  )}
								  </div>
								  <div>
									  <img src={image} alt={__t("Домейн .:tld", {tld: tld})}/>
								  </div>
							  </div>
						  </div>
					  </div>
					  <Prices tldId={tldId} tld={tld} domLabels={domLabels} priceTransfer={priceTransfer}
							  basePriceTransfer={basePriceTransfer}/>
					  {promoDateEnd != '' && (
						<div className={styles.ps}>
							<p>{__t('* Промоцията е валидна до :promoDateEnd г.', {promoDateEnd})}</p>
							{promoMessage != '' && <p>* {promoMessage}</p>}
						</div>
					  )}
				  </ContextServicePriceProvider>
				  <div className={styles.whiteBoxContainer}>
					  <div className={`${whiteBox.container}`}>
						  <h3>{__t('Специални (premium) домейни')}</h3>
						  <p>{__t('специалните-premium-домейни-се-различават-от-стан793f11')}</p>
						  <p>{__t('специалните-premium-домейни-могат-да-са-нови-доме57e2c1')}</p>
						  <p>{__t('при-домейните-които-се-регистрират-за-пръв-път-цеe7766f')}</p>
						  <p>{__t('цените-на-premium-домейните-започват-от-няколко-д92f30d')}</p>
						  <p>{__t('при-някои-от-premium-домейните-по-високата-цена-сf4681a')}</p>
						  <p>{__t('има-обаче-и-такива-premium-домейни-за-които-ценатe14a98')}</p>
						  {__t('още-информация-за-специалните-premium-домейни-мож9d6344')} &nbsp;
						  <a href={__t('https-help-superhosting-bg-special-premium-domaind85e2f')} target="_blank"
							 rel="noopener">
							  {__t('нашата помощна страница')}
						  </a>.

					  </div>
				  </div>
			  </section>
			  <ComponentFooter/>
		  </>
		);
	}
}

const Prices = ({tld, tldId, priceTransfer, basePriceTransfer, domLabels}) => {
	/** @type {ContextServicePriceProvider} */
	const context = useContext(ContextServicePrice);
	const prices = context.getVOForId(tldId);

	if (prices.length == 0) return;

	return (
	  <section className={styles.prices}>
		  <h2>{__t('Цени и периоди за домейн .:tld', {tld: tld})}</h2>
		  <table>
			  <thead>
			  <tr>
				  <th>{__t('Период')}</th>
				  <th>{__t('цена за регистрация')}</th>
				  <th>{__t('цена за подновяване')}</th>
				  <th>{__t('цена за трансфер')}</th>
			  </tr>
			  </thead>
			  <tbody>
			  {prices.map(price => (
				<tr key={price.id}>
					<td>
						{price.term}
						{price.termClear == 12 && domLabels.length > 0 && domLabels.map(label => (
						  <DomainLabelNew
							key={label.name}
							text={label.name}
							backgroundColor={'#' + label.background_color}
							textColor={'#' + label.text_color}/>
						))}
					</td>
					<td>
						<div className={styles.priceGroup}>
						{price.priceNewFormatted}
						{parseFloat(price.priceNew) < parseFloat(price.basePriceNew) &&
						  <span
							className={styles.oldPrice}>{FormatPrice(parseFloat(price.basePriceNew), price.currency)}</span>}
						</div>
						{SHVO.showEuroPrices && <>
							<div className={styles.priceGroup}>
								{FormatPrice(parseFloat(price.priceNewEUR), price.currencyEUR)}
								{parseFloat(price.priceNew) < parseFloat(price.basePriceNew) &&
								  <span
									className={styles.oldPrice}>{FormatPrice(parseFloat(price.basePriceNewEUR), price.currencyEUR)}</span>}
							</div>
						</>}
					</td>
					<td>
						<div className={styles.priceGroup}>
						{FormatPrice(parseFloat(price.priceRenew), price.currency)}
						{parseFloat(price.priceRenew) < parseFloat(price.basePriceRenew) &&
						  <span
							className={styles.oldPrice}>{FormatPrice(parseFloat(price.basePriceRenew), price.currency)}</span>}
						</div>
						{SHVO.showEuroPrices && <>
							<div className={styles.priceGroup}>
								{FormatPrice(parseFloat(price.priceRenewEUR), price.currencyEUR)}
								{parseFloat(price.priceRenew) < parseFloat(price.basePriceRenew) &&
								  <span
									className={styles.oldPrice}>{FormatPrice(parseFloat(price.basePriceRenewEUR), price.currencyEUR)}</span>}
							</div>
						</>}
					</td>
					<td>
						<div className={styles.priceGroup}>
							{price.termClear == 12 ? FormatPrice(parseFloat(priceTransfer.priceNew), priceTransfer.currency) : '-'}
							{price.termClear == 12 && parseFloat(priceTransfer.priceNew) < parseFloat(priceTransfer.basePriceNew) &&
							  <span
								className={styles.oldPrice}>{FormatPrice(parseFloat(priceTransfer.basePriceNew), priceTransfer.currency)}</span>}
						</div>
						{SHVO.showEuroPrices && <>
							<div className={styles.priceGroup}>
								{price.termClear == 12 ? FormatPrice(parseFloat(priceTransfer.priceNewEUR), priceTransfer.currencyEUR) : ''}
								{price.termClear == 12 && parseFloat(priceTransfer.priceNew) < parseFloat(priceTransfer.basePriceNew) &&
								  <span
									className={styles.oldPrice}>{FormatPrice(parseFloat(priceTransfer.basePriceNewEUR), priceTransfer.currencyEUR)}</span>}
							</div>
						</>}
					</td>
				</tr>
			  ))}

			  </tbody>
		  </table>
	  </section>
	);
}
const container = document.getElementById(SHVO.pageAppId);
const root = createRoot(container);
root.render(<PageDomainSingle data={SHVO.pageState}/>);